import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { checkPracticeUsage } from 'api/Practice';

export const usePracticeUsage = ({ serviceKindName, options = {} }) => {
  const navigate = useNavigate();

  return useQuery(
    ['practice-usage-limit', serviceKindName],
    () => checkPracticeUsage(navigate, { serviceKindName }),
    {
      enabled: !!serviceKindName,
      ...options
    }
  );
};
